var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNaviIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.349,
    height: 33.274,
    viewBox: "0 0 33.349 33.274",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21628",
    "data-name": "\\uADF8\\uB8F9 21628",
    transform: "translate(1.007 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10238",
    "data-name": "\\uD328\\uC2A4 10238",
    d: "M34.722,158.009c0,3.23-3.81,7.939-6.134,11.3a2.135,2.135,0,0,1-3.5,0c-2.323-3.357-6.134-8.066-6.134-11.3a8.161,8.161,0,0,1,7.885-8.412A8.162,8.162,0,0,1,34.722,158.009Z",
    transform: "translate(-11.169 -149.597)",
    fill: "none",
    stroke: "#adb5bd",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10239",
    "data-name": "\\uD328\\uC2A4 10239",
    d: "M29.032,157.322a2.426,2.426,0,1,1-2.426-2.451A2.438,2.438,0,0,1,29.032,157.322Z",
    transform: "translate(-10.938 -149.364)",
    fill: "none",
    stroke: "#adb5bd",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10240",
    "data-name": "\\uD328\\uC2A4 10240",
    d: "M18.814,166.61H15.766a1.351,1.351,0,0,0-1.294.963l-2.881,10.735c-.261.867.028,1.812.932,1.812h28.96a1.352,1.352,0,0,0,1.325-1.616L40.647,167.7a1.351,1.351,0,0,0-1.325-1.086H36.376",
    transform: "translate(-11.499 -148.845)",
    fill: "none",
    stroke: "#adb5bd",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaviIcon2);
export default __webpack_public_path__ + "static/media/NaviIcon2.2cd04dda5a932daea3568fc6ee4397fc.svg";
export { ForwardRef as ReactComponent };